import { Injectable } from '@angular/core';
import { DropdownComponent } from './dropdown.component';

@Injectable({
  providedIn: 'root'
})
export class DropdownService {
  private dropdowns: Array<DropdownComponent> = [];

  add(dropdown: DropdownComponent) {
    if (this.dropdowns.indexOf(dropdown) < 0) {
      this.dropdowns.push(dropdown);
    }
  }

  remove(dropdown: DropdownComponent) {
    const index = this.dropdowns.indexOf(dropdown);
    if (index >= 0) {
      this.dropdowns.splice(index, 1);
    }
  }

  contentMousedown(element: Element) {
    const parents = this.parents(element);

    const dropdowns = this.dropdowns.filter(
      dropdown => !!parents.find(ele => ele === dropdown.dropdownContent?.nativeElement)
    );

    for (const dropdown of dropdowns) {
      dropdown.contentMousedown();
    }
  }

  outsideMousedown(element: Element) {
    const children = this.children(element);

    const dropdowns = this.dropdowns.filter(dropdown => children.find(ele => ele === dropdown.element?.nativeElement));

    for (const dropdown of dropdowns) {
      dropdown.outsideMousedown();
    }
  }

  private parents(element: Element): Array<Element> {
    const parents: Array<Element> = [];
    while (element.parentElement) {
      element = element.parentElement;
      parents.push(element);
    }
    return parents;
  }

  private children(element: Element): Array<Element> {
    let children: Array<Element> = [];
    if (element.children && element.children.length > 0) {
      const elements = Array.prototype.slice.call(element.children);
      children = elements;

      for (const ele of elements) {
        children = this.children(ele).concat(children);
      }
    }

    return children;
  }
}
